import {
  FETCHED_BALANCE,
  FETCHED_NRG,

  WALLET_SET,
  REMOVE_ASSET,
  REMOVE_WALLET,
  FETCHED_FEE,
  TRADE_ADDRESS_SET,

  FETCHED_SPENDABLE_OUTPOINTS
} from '../actions/types';
import {assets} from '../config';

let wallet = window.getStorage('bc-wallet')
// let spendableOutpoints = window.getStorage('spendable-outpoints') ? window.getStorage('spendable-outpoints') : {}
let spendableOutpoints = {}


if(!wallet) wallet = {}
if(!spendableOutpoints) spendableOutpoints = {}

let tradeAddresses = window.getStorage('trade-addresses')
if(!tradeAddresses) tradeAddresses = {};


assets.map((a)=>{
  let wal = wallet[a.toLowerCase()];
  if(!wal){
    wallet[a.toLowerCase()] = {};
  }
  else if(wal && Object.keys(wal).length > 0){
    if(!tradeAddresses[a.toLowerCase()]){
      tradeAddresses[a.toLowerCase()] = Object.keys(wal)[0]
    }
  }
})


let initialState = {
  tradeAddresses,
  btc: {},
  neo: {},
  wav: {},
  lsk: {},
  eth: {},
  fee: 16600000000000 * 41 / Math.pow(10,18) ,
  emb: {},
  'l-emb':{},
  usdt: {},
  dai: {},
  unlockable:{},
  nrg: {},
  nrg_collateralized: {},
  spendableOutpoints,
  wallet: wallet ? wallet : {},
};

export default function(state: Object = initialState, action) {
  switch (action.type) {
    case FETCHED_FEE:
      return { ...state, fee: action.payload}
    case FETCHED_BALANCE:
      let newstate = state;
      newstate[action.payload.asset][action.payload.address] = action.payload.balance;
      return { ...newstate}
    case FETCHED_NRG:
      newstate = state;
      Object.keys(action.payload).map((a)=>{
        if(a!='address'){
          newstate[a][action.payload.address] = action.payload[a];
        }
      })
      return { ...newstate};
    case FETCHED_SPENDABLE_OUTPOINTS:
      newstate = state;
      newstate.spendableOutpoints[action.payload.address] = action.payload.outpoints;
      try {
        // window.setStorage(`spendable-outpoints`,JSON.stringify(newstate.spendableOutpoints));
      }
      catch(err){

      }
      return {...newstate}
    case TRADE_ADDRESS_SET:
      let tradeAddresses = state.tradeAddresses;
      tradeAddresses[action.payload.chain] = action.payload.address;
      window.setStorage(`trade-addresses`,JSON.stringify(tradeAddresses))
      return {...state, tradeAddresses};
    case WALLET_SET:
      tradeAddresses = state.tradeAddresses;
      assets.map((a)=>{
        let wal = wallet[a.toLowerCase()];
        if(!wal ||  Object.keys(wal).length == 0){
          delete tradeAddresses[a.toLowerCase()];
        }
        else if(wal && Object.keys(wal).length > 0){
          if(!tradeAddresses[a.toLowerCase()]){
            tradeAddresses[a.toLowerCase()] = Object.keys(wal)[0]
          }
        }
      })
      window.setStorage('bc-wallet',JSON.stringify(action.payload));
      return {...state, wallet: action.payload, tradeAddresses};
    case REMOVE_WALLET:
      wallet = {};
      return {...state, wallet, tradeAddresses: {}, pendingTransactions: {},
      nrg:[0],nrg_collateralized:[0],btc:[0],eth:[0],emb:[0],total_emb:[0],lsk:[0],neo:[0],wav:[0]};
    case REMOVE_ASSET:
      tradeAddresses = state.tradeAddresses;
      let a = action.payload.asset.toLowerCase();
      if(tradeAddresses[a] === action.payload.address){
        let wal = wallet[a];
        if(!wal ||  Object.keys(wal).length == 0){
          delete tradeAddresses[a];
        }
        else if(wal && Object.keys(wal).length > 0){
          tradeAddresses[a] = Object.keys(wal)[0]
        }
      }
      window.setStorage(`trade-addresses`,JSON.stringify(tradeAddresses))
      // newstate = state;
      // newstate[action.payload] = [0]
      return {...state, tradeAddresses}
    default:
      return state;
  }
}
